<template>
    <v-fade-transition>
        <v-btn
                @focus="cancelFocus"
                v-scroll="onScroll"
                v-show="fab"
                ref="btn"
                fab
                height="50"
                width="50"
                dark
                fixed
                bottom
                right
                @click="toTop"
        >
            <v-icon>{{icon_up}}</v-icon>
        </v-btn>
    </v-fade-transition>
</template>

<script>
    import {mdiChevronUp} from "@mdi/js";

    export default {
        name: "TopButton",
        data() {
            return {
                icon_up: mdiChevronUp,
                fab: false,
            }
        },
        methods: {
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0;
                this.fab = top > 600;
            },
            toTop() {
                this.$vuetify.goTo(0);
            },
            cancelFocus(e) {
                e.target.blur();
            }
        }
    }
</script>

<style scoped>

</style>